import s from './BlockList.scss'
import MaterialTable from '@material-table/core'
import { timezoneDate } from 'utils/helpers'
import { FaClone } from 'react-icons/fa'

const columns = [
  { title: 'Name', field: 'name', defaultSort: 'asc' },
  { title: 'Visibility', field: 'visible' },
  {
    title: 'Created By',
    field: 'createdBy'
  },
  {
    title: 'Created On',
    field: 'createdAt',
    render: row => timezoneDate(row.createdAt, 'hh:mm A')
  },
  {
    title: 'Last Modified By',
    field: 'updatedBy'
  },
  {
    title: 'Last Modified On',
    field: 'updatedAt',
    render: row => timezoneDate(row.updatedAt, 'hh:mm A')
  }
]

const BlockList = ({ category, blocks, deleteBlock, openEditModal, cloneBlock }) => {
  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title={category}
        columns={columns}
        data={blocks}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={[
          () => ({
            icon: 'edit',
            tooltip: 'Edit Block',
            onClick: (event, rowData) => openEditModal(rowData)
          }),
          () => ({
            icon: () => <FaClone />,
            tooltip: 'Clone Block',
            onClick: (event, rowData) => cloneBlock(rowData.id)
          }),
          rowData => ({
            icon: 'delete',
            tooltip: 'Delete Block',
            onClick: (event, rowData) => deleteBlock(rowData.id),
            disabled: rowData.system
          })
        ]}
      />
    </div>
  )
}

export default BlockList
